module.exports = __webpack_public_path__ + "img/rockstaripphonerender1_00089.c63e630.png";